<template>
  <div>
    <label :for="id">
      {{label}}
      <div class="dropzone dropzone-previews dz-clickable" style="position: relative;">
        <input
          multiple
          type="file"
          :id="id"
          ref="file"
          @change="onSelect($event.target.files)"
          class="input-file"
          :disabled="filenames.length >= max"
        />

        <div class="dz-message" v-if="!uploadedFiles.length">
          <i class="material-icons">cloud_upload</i>
          {{ descricao }}
        </div>

        <div class="image-box row" v-else>
          <div class="col sm3 image-column" v-for="item in uploadedFiles" @click.prevent>
            <!--DIV DE CARREGAMENTO COMPLETO, CASO AINDA ESTEJA FAZENDO UPLOAD-->
            <i class="material-icons top-icon check" v-if="item.completed">check_circle</i>
            <!--DIV DE ERRO, CASO DE ERRO NO UPLOAD-->
            <i class="material-icons top-icon error" v-else-if="item.error">error</i>
            <!--DIV DO ITEM FEITO UPLOAD-->
            <div class="img-wrapper" v-if="tipo==2 && item.content">
              <video width="320" height="240" controls>
                <source :src="item.content" type="video/mp4" />
              </video>
            </div>
            <!--DIV DE CARREGAMENTO DE PROGRESSSO-->
            <div class="progress" v-if="!item.completed && !item.error">
              <div class="determinate" :style="'width: ' + item.progress + '%'"></div>
            </div>
            <!--DIV DE DELETE FILE-->
            <a @click.prevent="removefile(item)" style="cursor: pointer;" v-if="item.completed">
              <i class="material-icons">delete</i> Remover
            </a>
            <!--DIV PARA TENTAR NOVAMENTE CASO DE ERRO-->
            <a @click.prevent="tryAgain(item)" style="cursor: pointer;" v-if="item.error">
              <i class="material-icons">replay</i> Tentar novamente
            </a>
          </div>
        </div>

        <!--DIV PARA MSG DE ERRO-->
        <div class="footer-message error" v-if="uploadedFiles.length > 0 && hasError">
          <span>
            <i class="material-icons">error</i> Tem erro, reenvie
          </span>
        </div>
        <!--DIV PARA MSG DE UPLOAD-->
        <div class="footer-message notice" v-else-if="uploadedFiles.length > 0 && !allCompleted">
          <span>
            <i class="material-icons">file_upload</i> Enviando...
          </span>
        </div>
        <!--FIM DIV DE FORMULARIO-->
      </div>
    </label>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      default: []
    },
    label: String,
    descricao: String,
    tipo: String,
    max: {
      type: String,
      default: "1"
    }
  },
  data() {
    return {
      file: null,
      message: "",
      id: Math.random().toString(36),
      uploadedFiles: [],
      filenames: []
    };
  },
  methods: {
    onSelect(fileList) {
      if (!fileList.length) return;

      //pegar o contexto daqui
      let that = this;

      that.file = fileList[0];
      let filename = "";
      let extension = "";
      let ValidImageTypes = [];

      //verifica os parametros de validacao
      if (that.tipo == 1) {
        ValidImageTypes = ["image/gif", "image/jpeg", "image/png"];
        extension = ".jpg";
      } else if (that.tipo == 2) {
        ValidImageTypes = ["video/mp4"];
        extension = ".mp4";
      }

      console.log("File-->", that.file);

      //nao poder ser maior que 200 mb
      if (that.file.size <= 209715200) {
        //valida de acordo com os parametros encontrados
        if (ValidImageTypes.indexOf(that.file.type) !== -1) {
          //cria um nome do arquivo com a sua extensao
          filename = "file-" + moment().format("DDMMYYYYHHmmss") + extension;
          console.log(filename);

          let item = {
            content: null,
            progress: 0,
            completed: false,
            error: false,
            upload: null,
            filename: null
          };

          that.uploadedFiles.push(item);

          //um reader para pegar o base64 desse arquivo
          let reader = new FileReader();

          //este vento consegue pegar o base64
          reader.addEventListener("load", function(event) {
            //atualiza o content
            item.content = event.target.result;
            let option = {
              endpoint: "/files",
              uploadUrl: "/files",
              retryDelays: [0, 3000, 5000, 10000, 20000],
              resume: false,
              metadata: {
                filename: filename,
                filetype: that.file.type
              },
              onError: function(error) {
                console.log("Erro no Upload: " + error);
                Vue.set(item, "error", true);
              },
              onProgress: function(bytesUploaded, bytesTotal) {
                var percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(
                  2
                );
                console.log("Progresso: " + percentage + "%");
                Vue.set(item, "progress", percentage);
              },
              onSuccess: function() {
                console.log(
                  "Download %s from %s",
                  upload.file.name,
                  upload.url
                );
                Vue.set(item, "filename", filename);
                setTimeout(function() {
                  Vue.set(item, "completed", true);
                }, 1000);
                that.filenames.push(filename);
                that.$emit("input", that.filenames);
              }
            };
            //cria instancia upload
            let upload = new window.tus.Upload(that.file, option);
            // Inicia o upload
            upload.start();
            item.upload = upload;
          });
          //mas aqui que ele dispara para pegar
          reader.readAsDataURL(that.file);
        } else {
          Materialize.toast({ html: "Formato de arquivo inválido" });
        }
      } else {
        Materialize.toast({ html: "O arquivo não pode ser maior que 200 MB" });
      }
    },
    removefile: function(item) {
      if (!confirm("Deseja relamente excluir esta imagem?")) return false;

      this.uploadedFiles = this.uploadedFiles.filter(
        x => x.filename !== item.filename
      );
      this.filenames = this.filenames.filter(x => x !== item.filename);

      this.$emit("input", this.filenames);
    },
    tryAgain(item) {
      item.error = false;
      item.upload.start();
    }
  },
  computed: {
    allCompleted() {
      return (
        this.uploadedFiles.filter(x => x.completed === true).length ===
        this.uploadedFiles.length
      );
    },
    hasError() {
      return this.uploadedFiles.filter(x => x.error === true).length > 0;
    }
  },
  created() {
    let that = this;
    if (this.value) {
      this.filenames = this.value;
    }

    that.filenames.forEach(function(filename) {
      if (
        that.uploadedFiles.filter(x => x.filename === filename).length === 0
      ) {
        that.uploadedFiles.push({
          content: filename,
          progress: 100,
          completed: true,
          error: false,
          upload: null,
          filename: filename
        });
      }
    });
  },
  watch: {
    value: function(value) {
      let that = this;

      this.filenames = value;
      that.filenames.forEach(function(filename) {
        if (
          that.uploadedFiles.filter(x => x.filename === filename).length === 0
        ) {
          that.uploadedFiles.push({
            content: filename,
            progress: 100,
            completed: true,
            error: false,
            upload: null,
            filename: filename
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.dropzone {
  cursor: pointer;
}

.dz-file-preview {
  margin-top: 15px;
}

.dz-image {
  min-height: 150px;
}

.img-wrapper {
  overflow: hidden;
  margin-bottom: 5px;
  border-radius: 5px;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  text-align: center;
  position: absolute;
  cursor: pointer;
}

.image-box {
  display: table;

  .image-column {
    border: 1px solid #aaa;
    border-radius: 9px;
    margin: 0 7px 10px 0;
    padding: 10px;
    position: relative;

    i.top-icon {
      position: absolute;
      z-index: 9;
      right: 2px;
      background-color: white;
      border-radius: 35px;
      border: 0;
      top: 5px;

      &.check {
        color: #1bb240;
      }

      &.error {
        color: red;
      }
    }
  }
}

.footer-message {
  width: 100%;
  color: white;
  position: absolute;
  bottom: 0;
  left: 0;
  text-align: center;
  font-size: 14px;

  span {
    position: relative;
    top: -2px;

    i {
      position: relative;
      top: 5px;
    }
  }

  &.check {
    background-color: #1bb240;
  }

  &.notice {
    background-color: #bdbdbd;
  }

  &.error {
    background-color: #ef5350;
  }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/utils/FileUploadGeneric.vue